import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { App } from './App';
import { StartPage } from '../pages/StartPage';
import { PreparationPage } from '../pages/PreparationPage';
import { ContextPage } from '../pages/ContextPage';
import { TestQuestionPage } from '../pages/TestQuestionPage';
import { ReviewPage } from '../pages/ReviewPage';
import { ResultPage } from '../pages/ResultPage';
import { AboutPage } from '../pages/AboutPage';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * Routen gemäß Abschnitt 8.1. Kein SSR- oder Framework-Modus, reine clientseitige SPA.
 * Als Route-Objekte exportiert, damit Tests einen frischen `createMemoryRouter` je Testfall
 * aufbauen können statt den `createBrowserRouter`-Singleton der Anwendung zu teilen.
 */
export const routeObjects: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <StartPage /> },
      { path: 'vorbereitung', element: <PreparationPage /> },
      { path: 'kontext/angebot', element: <ContextPage group="angebot" /> },
      { path: 'kontext/instagram', element: <ContextPage group="instagram" /> },
      { path: 'kontext/arbeitsweise', element: <ContextPage group="arbeitsweise" /> },
      { path: 'test/:number', element: <TestQuestionPage /> },
      { path: 'pruefen', element: <ReviewPage /> },
      { path: 'ergebnis', element: <ResultPage /> },
      { path: 'ueber-den-test', element: <AboutPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export const router = createBrowserRouter(routeObjects);
